var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticClass:"rounded",attrs:{"width":"150","height":"100","controls":""}},[_c('source',{attrs:{"src":_vm.urlVideo,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }